import { render, staticRenderFns } from "./tit-section.vue?vue&type=template&id=468d0193&"
import script from "./tit-section.vue?vue&type=script&lang=js&"
export * from "./tit-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports